import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-menu', 
  templateUrl: './master-menu.component.html',
  styleUrls: ['./master-menu.component.css']
})
export class MasterMenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Master')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/unicore-masters/master-menu/master-menu.component.ts